import React from "react";
import {
  QUESTION_TYPE,
  type CodingPreviewModel,
} from "./questionPreviewAdapter";
import PythonCodingPreview from "./PythonCodingPreview";
import SqlCodingPreview from "./SqlCodingPreview";
import FrontendCodingPreview from "./FrontendCodingPreview";

type CodingQuestionPreviewProps = {
  model: CodingPreviewModel;
};

/** Routes coding preview by QUESTION_TYPE to student-faithful layouts. */
const CodingQuestionPreview: React.FC<CodingQuestionPreviewProps> = ({
  model,
}) => {
  if (model.kind === QUESTION_TYPE.SQL_CODING) {
    return <SqlCodingPreview model={model} />;
  }
  if (model.kind === QUESTION_TYPE.FRONTEND_CODING) {
    return <FrontendCodingPreview model={model} />;
  }
  return <PythonCodingPreview model={model} />;
};

export default CodingQuestionPreview;
